import type { TAthleteStatsSubType, TAthleteStatsType } from "~/athletes/types/athlete-stats";
import type { TSportType } from "~/teams/types/teams";

// Mapping from sport type to available stat types according to existing stat sheets
// Related to Team Roster stats and Athlete stats

// Missing stat types are not available for the sport
// Commented out stat types are not available for the sport at moment, but should be added in the future

const availableStatTypesForAthleteStats: Record<TSportType, Partial<Record<TAthleteStatsType, TAthleteStatsSubType[]>>> = {
  basketball: {
    "box-score": ["average", "total"],
    shooting: ["average", "total"],
    advanced: ["average", "total"],
  },
  soccer: {
    basic: ["average", "total"],
  },
  fieldhockey: {
    basic: ["average", "total"],
  },
  "outdoor-football": {
    basic: ["average", "total"],
  },
  volleyball: {
    basic: ["average", "total"],
  },
  handball: {
    basic: ["average", "total"],
  },
  futsal: {
    basic: ["average", "total"],
  },
  hockey: {
    // "advanced": ["average", "total"],
    "box-score": ["average", "total"],
  },
  softball: {
    basic: ["average", "total"],
  },
  baseball: {
    basic: ["average", "total"],
  },
  "lacrosse-men": {
    basic: ["average", "total"],
  },
  "lacrosse-women": {
    basic: ["average", "total"],
  },
  "flag-football": {
    basic: ["average", "total"],
  },
  rugby: {},
  american_football: {},
  "canadian-football": {},
  rollerhockey: {},
  wrestling: {},
  gymnastics: {},
  beachvolleyball: {},
  lacrosse: {},
  snooker: {},
  floorball: {},
  cricket: {},
  "water-polo": {},
  netball: {},
  badminton: {},
  bowling: {},
  swimming: {},
  other: {},
};

export function getAvailableStatTypes(sportType: TSportType): { types: TAthleteStatsType[]; subTypes: TAthleteStatsSubType[] } {
  const sportStatsTypes = availableStatTypesForAthleteStats[sportType] || {};

  if (!sportType || !sportStatsTypes) {
    return { types: [], subTypes: [] };
  }

  return {
    types: Object.keys(sportStatsTypes) as TAthleteStatsType[],
    subTypes: [...new Set(Object.values(sportStatsTypes).flat())] as TAthleteStatsSubType[],
  };
}

export function getSportTypesWithStatSheetsForAthleteStats(): TSportType[] {
  const sportTypes = Object.keys(availableStatTypesForAthleteStats) as TSportType[];
  return sportTypes.filter((sportType) => Object.keys(availableStatTypesForAthleteStats[sportType]).length > 0);
}
